import request from './base/api';

/**
 * 驗證折扣碼 API
 * @param {Object} params - 驗證參數
 * @param {Number} params.program_id - 方案 ID
 * @param {Number} params.member_id - 會員 ID
 * @param {String} params.discount_code - 折扣碼
 * @param {Function} cb - 成功回調
 * @param {Function} errCb - 失敗回調
 */
export function validateDiscountCode(
  { program_id, member_id, discount_code },
  cb,
  errCb
) {
  const config = {
    data: {
      program_id,
      member_id,
      discount_code
    }
  };

  return request({
    url: `shopping/discount-code`,
    method: 'post',
    cb,
    errCb,
    config
  });
}

export default {
  validateDiscountCode
};
